<div class="container-general" style="height: 100%">
    <div class="cards-container">
        <span class="title-suc">Cajas de {{ branch?.name }}</span>
        <div *ngIf="loadingData">
            <mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
        </div>
        <div *ngIf="!loadingData" style="width: 100%">
            <div class="sucursal-info-container" *ngFor="let caja of cajas | paginate: { id: 'cajas', itemsPerPage: 4, currentPage: cajaActual }">
                <div class="sucursal-info">
                    <div class="info-caja">
                        <span class="suc-name">{{ caja.nombre }}</span
						><br />
						<span class="address">Código de caja: {{ caja.id }}</span>
                    </div>
                    <div style="display: flex; align-items: center">
                        <button mat-icon-button style="display: flex; align-items: center; justify-content: center" (click)="generarQR(caja)">
							<mat-icon style="color: #FF6600">qr_code</mat-icon>
						</button>
                        <button mat-icon-button style="display: flex; align-items: center; justify-content: center" (click)="editClickEventHandlerCahier(caja)">
							<mat-icon style="color: #FF6600">edit</mat-icon>
						</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="sin-datos" *ngIf="cajas?.length === 0">
            <span style="cursor: default">No tenés ninguna caja asignada a {{ branch?.name }}</span>
        </div>
        <div class="paginator-container" *ngIf="cajas?.length !== 0">
            <pagination-controls id="cajas" class="my-pagination" maxSize="7" previousLabel="" nextLabel="" (pageChange)="cajaActual = $event"></pagination-controls>
        </div>

        <div style="width: 82%">
            <button mat-raised-button (click)="goToAgregarCaja(false)" style="
					width: 160px;
					background-color: #FF6600;
					color: white;
					box-shadow: none;
					border-radius: 8px;
					margin-left: 1rem;
				">
				Agregar caja
			</button>
        </div>
        <br />
        <span class="title-suc">Responsables</span>
        <div *ngIf="loadingData">
            <mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
        </div>
        <div *ngIf="!loadingData" style="width: 100%">
            <div class="sucursal-info-container" *ngFor="
					let responsable of responsables | paginate: { id: 'responsables', itemsPerPage: 4, currentPage: responsableActual }
				">
                <div class="sucursal-info" style="display: flex; flex-direction: row; justify-content: space-between">
                    <div class="info-caja">
                        <span class="suc-name">{{ responsable.nombre + ' ' + responsable.apellido }}</span
						><br />
						<span class="address">Código: {{ responsable.id }} - Estado: {{ evaluarEstado(responsable.estado) }}</span>
                    </div>
                    <div style="display: flex; align-items: center" *ngIf="!loggedUser?.isResponsible">
                        <button mat-icon-button style="display: flex; align-items: center; justify-content: center" (click)="editClickEventHandler(responsable)">
							<mat-icon style="color: #FF6600">edit</mat-icon>
						</button>
                        <button mat-icon-button style="display: flex; align-items: center; justify-content: center" (click)="removeClickEventHandler(responsable)">
							<mat-icon style="color: #FF6600">delete</mat-icon>
						</button>
                    </div>
                </div>
            </div>
            <div class="sin-datos" *ngIf="responsables?.length === 0">
                <span style="cursor: default">No tenés ningún responsable asignado a {{ selectedBranch?.nombre }}</span>
            </div>
            <div class="paginator-container" *ngIf="responsables?.length !== 0">
                <pagination-controls id="responsables" class="my-pagination" maxSize="7" previousLabel="" nextLabel="" (pageChange)="responsableActual = $event"></pagination-controls>
            </div>
        </div>

        <div style="width: 82%">
            <button mat-raised-button (click)="goToAgregarUsuario(false)" *ngIf="!loggedUser?.isResponsible" [disabled]="loadingData" style="background-color: #FF6600; color: white; box-shadow: none; border-radius: 8px; margin-left: 1rem">
				Agregar responsable
			</button>
        </div>
        <div style="width: 100%;margin-top: 1rem">
            <div style="display: flex; justify-content: flex-end">
                <button mat-stroked-button (click)="sendResetShowInfo()" style="
						background-color: white;
						color: #FF6600;
						box-shadow: none;
						border-radius: 8px;
						margin-left: 1rem;
						border: 2px solid #FF6600;
					">
					Volver
				</button>
            </div>
        </div>
    </div>
</div>
